import { createStore } from 'vuex'
import getters from './getters'
import app from './app'

export default createStore({
  state: {
    curUser: window.SessionStorage.get("CurUser") || {}
  },
  getters,
  mutations: {
    setCurUser (state, _curUser) {
      state.curUser = _curUser;
      window.SessionStorage.set("CurUser", _curUser);
    }
  },
  actions: {
  },
  modules: {
    app
  }
})
